// EVENTS.VIEWS.APP.REPORTS.WEB_SECURITY_HEADERS

export const WEB_SECURITY_HEADERS = {
  PAGE_VISITED: 'web_security_headers_report-page_visited'
};
